import React, { useEffect } from 'react'
import Bredcom from '../../Bredcom/Main'
import Header from '../../headerone/Main'
import Blog from '../../menhome/Blog'
import Newlast from '../../menhome/Newlast'
import StrategicP from '../menstrategicpla/StrategicP'


function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Strategic-Plan";
  }, [])

  return (
    <>
        <Header/>

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Home"
            title="strategic plan"
            subtitledown="Strategic Plan"
           />
            <StrategicP/>
            <Blog/>
            <Newlast/>
        </div>
    </>
  )
}

export default Main